/* asynckit/index */ function _(require, module, exports) {
    module.exports =
        {
            parallel: require(59) /* ./parallel.js */,
            serial: require(60) /* ./serial.js */,
            serialOrdered: require(61) /* ./serialOrdered.js */
        };
}
